import lodash, { size } from 'lodash'
import React, { ReactElement } from 'react'
import styled from 'styled-components'

import Field, {
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import ToggleSwitch from '../../../../../../../1stlog-ui/src/components/ToggleSwitch'
import { getNotificationTriggerLabels } from '../../../../../../../1stlog-ui/src/constants/notificationTriggers'

const Wrapper = styled.div``

type TNameProps = {
  name: string
}

const Name = (props: TNameProps): ReactElement => {
  const { name } = props

  const trigger = useField('trigger')

  const labels = getNotificationTriggerLabels()

  const types = useField('types')

  const isEmail = size(types) === 1 && types[0] === 'email'

  return (
    <Wrapper>
      <Field name="isEnabled" noMargin>
        <ToggleSwitch
          id={name}
          label={`${lodash.get(labels, trigger)}${
            isEmail ? ` (${i18n.t('via_email', 'per E-Mail')})` : ''
          }`}
        />
      </Field>
    </Wrapper>
  )
}

export default Name
